import { useParams } from "react-router-dom";
import { useProjectStore } from "@/frontend/store/ProjectStore";
import { useProcedureListStore } from "@/frontend/store/ProcedureListStore";
import { useShallow } from "zustand/react/shallow";
import { useEffect, useState } from "react";
import { NotFound } from "@/frontend/pages/NotFound";
import { ProjectProcedureInstanceAssignments } from "./ProjectProcedureInstanceAssignments";
import { I18n } from "@/i18n/I18n";
import { LoadingSpinner } from "../LoadingSpinner";

export function ProjectTemplatesPage() {
  const projectId = useParams().projectId;
  const project = useProjectStore(useShallow(state => state.projects.find(p => p.id === projectId)));
  const fetchAssignmentsByProjectId = useProjectStore(state => state.fetchAssignmentsByProjectId);
  const readPublishedTemplatesForEnterprise = useProcedureListStore(state => state.readPublishedTemplatesForEnterprise);
  const readAllGeneratedProceduresForProject = useProcedureListStore(state => state.readAllGeneratedProceduresForProject);
  const readAllProcedureInstancesAssignedToProject = useProcedureListStore(state => state.readAllProcedureInstancesAssignedToProject);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadItems = async () => {
      if(projectId) {
        setLoading(true);
        await Promise.all([
          fetchAssignmentsByProjectId(projectId),
          readPublishedTemplatesForEnterprise(),
          readAllGeneratedProceduresForProject(projectId),
          readAllProcedureInstancesAssignedToProject(projectId)
        ]);
        setLoading(false);
      }
    };
    void loadItems();
  }, [fetchAssignmentsByProjectId, readPublishedTemplatesForEnterprise, readAllGeneratedProceduresForProject, readAllProcedureInstancesAssignedToProject, projectId]);

  if (!project) {
    return <NotFound />;
  }

  return (
    <div className="p-3">
      <div className="list-card">
        <p className="list-card-title"> {I18n.get('templates')}</p>
        {loading ? <LoadingSpinner /> : <ProjectProcedureInstanceAssignments project={project} />}
      </div>
    </div>
  );
}
